import Markdown from 'markdown-to-jsx';
import { useContext } from 'react';
import { AppContext } from 'providers/AppProvider';

export function RiskqLegend({ page }: Readonly<{ page: string }>) {
	const { t } = useContext(AppContext);

	if ('appropriateness_2' === page || 'appropriateness_3' === page) {
		return (
			<Markdown className="arionui mb-5" options={{ forceBlock: true }}>
				{t(`${page}_legend`, 'testRisk')}
			</Markdown>
		);
	}

	return null;
}
